import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  currentIndex: number
  isFullScreen: boolean
  isScrollFromTop: boolean
}
interface Action {
  setIsFullScreen: (isFullScreen: State['isFullScreen']) => void
  setCurrentIndex: (currentIndex: State['currentIndex']) => void
  setIsScrollFromTop: (isScrollFromTop: State['isScrollFromTop']) => void
  reset: () => void
}

const baseStoreHomeHero = create<State & Action>((set) => ({
  currentIndex: 0,
  isFullScreen: true,
  isScrollFromTop: false,
  setIsScrollFromTop: (isScrollFromTop) => set({ isScrollFromTop }),
  setCurrentIndex: (currentIndex) => set({ currentIndex }),
  setIsFullScreen: (isFullScreen) => set({ isFullScreen }),
  reset: () =>
    set({
      currentIndex: 0,
      isScrollFromTop: false,
      isFullScreen: true
    })
}))

const useStoreHomeHero = createSelectors(baseStoreHomeHero)

export default useStoreHomeHero
